import { css } from '@emotion/css';
import React from 'react';
import { ReactComponent as Cycle } from '../../../assets/images/cycle.svg';
import { ClassicLoading } from '../ClassicLoading';

interface RefreshButtonProps {
  isRefreshing: boolean;
  handleRefreshClick: () => void;
  ariaLabel?: string;
}

export const RefreshButton: React.FC<RefreshButtonProps> = ({
  isRefreshing,
  handleRefreshClick,
  ariaLabel
}) => {
  return (
    <button
      disabled={isRefreshing}
      className={css`
        display: flex;
        justify-content: center;
        align-items: center;
        background: #897a66;
        border-radius: 50%;
        position: relative;
        width: 48px;
        height: 48px;
        transition: transform 0.1s cubic-bezier(0.17, 0.89, 0.32, 1.49), background-color 0.1s;
        padding: 0;
        svg {
          margin: auto;
        }
        :disabled {
          pointer-events: none;
        }
        &:active {
          transform: scale(0.85);
        }
      `}
      onClick={handleRefreshClick}
      aria-label={ariaLabel}
    >
      {isRefreshing ? (
        <ClassicLoading color={'#F5F1E3'} size={36} dotRadius={2} style={{ margin: 'auto' }} />
      ) : (
        <Cycle />
      )}
    </button>
  );
};
